import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

/**
 * @param {{
 *    headRows: {
 *        label: string
 *        width: number
 *    }[]
 *    containerId: string
 *    rowTemplate: any
 *    filas: any[]
 *    maxRowsShown: number
 *    tablaDetalle: Boolean
 * }} props
 * @returns {React.Component}
 */
const ZariTable = ({ containerId, headRows, rowTemplate, filas, maxRowsShown, tablaDetalle, className }) => {
  const styleCalculated = () => {
    if (maxRowsShown) {
      return { maxHeight: `${maxRowsShown * 28 + 30}px`, overflow: 'auto' }
    }

    if (tablaDetalle) {
      return {
        maxHeight: '165px',
        overflow: 'auto'
      }
    }

    return {}
  }

  return (
    <div style={styleCalculated()} id={containerId}>
      <Table
        aria-labelledby='tableTitle'
        size='small'
        className={clsx(
          'zr-table',
          {
            'zr-table--detalles': tablaDetalle
          },
          className
        )}
      >
        <TableHead className='zr-thead'>
          <TableRow className='zr-tr'>
            {headRows.map((row, k) => (
              <TableCell
                className='zr-th'
                key={k}
                align='center'
                style={
                  row.width
                    ? {
                        width: `${row.width}px`,
                        minWidth: `${row.width}px`,
                        maxWidth: `${row.width}px`
                      }
                    : {}
                }
                padding='default'
              >
                {row.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className='zr-tbody'>{filas.map(rowTemplate)}</TableBody>
      </Table>
    </div>
  )
}

ZariTable.propTypes = {
  headRows: PropTypes.arrayOf(PropTypes.object),
  rowTemplate: PropTypes.any,
  filas: PropTypes.array,
  maxRowsShown: PropTypes.number,
  tablaDetalle: PropTypes.bool,
  containerId: PropTypes.string
}

export default ZariTable
